import React from 'react';
import { useForm } from 'react-hook-form';
import useMoreFilters from '@/components/search/hooks/useMoreFilters';
import styles from './MoreFiltersMobile.module.scss';
import Icon from '@/components/UI/icon/Icon';
import Button from '@/components/UI/button/Button';
import Box from '@/components/UI/box/Box';
import { InputComponent } from '../reusable/inputComponent/InputComponent';
import Typography from '@/components/UI/typography/Typography';
type IMoreFiltersMobile = {
  onClose: () => void;
  setQuery: any;
  queryParams: any;
  handleClean: any;
};
const MoreFiltersMobile = ({
  onClose,
  queryParams,
  setQuery,
  handleClean
}: IMoreFiltersMobile) => {
  const {
    handleSubmit,
    control
  } = useForm();
  const {
    moreFilters,
    updateQueries
  } = useMoreFilters();
  const onSubmit = form => {
    updateQueries({
      setQuery,
      form
    });
  };
  return <Box className={styles['more-filters-mobile-container']} data-sentry-element="Box" data-sentry-component="MoreFiltersMobile" data-sentry-source-file="MoreFiltersMobile.tsx">
      <form id="hook-form" className={styles['more-filters-form']} onSubmit={handleSubmit(onSubmit)}>
        <Box className={styles['more-filters-header']} data-sentry-element="Box" data-sentry-source-file="MoreFiltersMobile.tsx">
          <Box onClick={onClose} className={styles['close-icon-section']} data-sentry-element="Box" data-sentry-source-file="MoreFiltersMobile.tsx">
            <Icon name="close" type="highEmphasis" size={'large'} data-sentry-element="Icon" data-sentry-source-file="MoreFiltersMobile.tsx" />
          </Box>
          <Typography variant="title_Bold" data-sentry-element="Typography" data-sentry-source-file="MoreFiltersMobile.tsx">فیلترها</Typography>
        </Box>

        <Box className={styles['more-filter-main-container']} data-sentry-element="Box" data-sentry-source-file="MoreFiltersMobile.tsx">
          {moreFilters.map((item, index) => {
          if (queryParams.mid_term && !item?.is_mid_term) {
            return <></>;
          }
          return <Box key={'MORE_FILTER_' + index} className={styles['more-filter-accordion']}>
                <InputComponent data={item} control={control} queryParams={queryParams} />
              </Box>;
        })}
        </Box>

        <Box className={styles['more-filters-footer']} data-sentry-element="Box" data-sentry-source-file="MoreFiltersMobile.tsx">
          <Button onClick={handleClean} format="text" data-sentry-element="Button" data-sentry-source-file="MoreFiltersMobile.tsx">
            حذف فیلتر ها
          </Button>
          <Button format="primary" type="submit" data-sentry-element="Button" data-sentry-source-file="MoreFiltersMobile.tsx">
            اعمال فیلتر
          </Button>
        </Box>
      </form>
    </Box>;
};
export default React.memo(MoreFiltersMobile);